import LedgerRow from './financial.ledger.component';
import utilsProvider from '../../providers/utils.provider';

const FREE_LABEL = 'Grátis';

const SINGLE_CHARGE = 1;

const hintOf = (service) => service.billingIds.length > SINGLE_CHARGE
    ? [service.billingIds.length, 'x'].join('')
    : null;

const amountOf = (service) => Number(service.amount) === 0
    ? FREE_LABEL
    : (utilsProvider.formatNumberCurrency(service.amount) || '—');

const totalOf = (prices) => prices
    .reduce((total, price) => total + (parseFloat(price.amount) || 0), 0);

const PackageBlock = ({ group, isFirst }) => (
    <div className={isFirst ? '' : 'mt-3'}>
        <p className="m-0 mb-1 text-sm font-semibold text-[#1d1d1f]">
            {group.packageDescription}
            <span className="ml-1.5 text-[11px] font-normal text-gray-400">#{group.packageId}</span>
        </p>

        {group.services.map((service, index) => (
            <LedgerRow
                key={[service.serviceId, index].join('-')}
                label={service.label}
                hint={hintOf(service)}
                value={amountOf(service)}
            />
        ))}
    </div>
);

export default function FinancialCustomerSection({ groups, prices }) {
    return (
        <>
            {groups.map((group, index) => (
                <PackageBlock key={group.packageId} group={group} isFirst={index === 0} />
            ))}

            <LedgerRow label="Total" value={utilsProvider.formatNumberCurrency(totalOf(prices))} isTotal />
        </>
    );
}
